export default __webpack_public_path__ + "static/media/gum1.6975a000.png";